import React, { useContext, useState, useEffect } from 'react';
import "./navbar.css";
import NavContext from '../../contexts/NavContext';
import Logo from '../../assets/images/Mask group.png';
import ArrowDown from '../../assets/icons/arrow-down.svg';
import Profile from '../../assets/icons/profile.svg';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import PopupDisplay from '../popup/popup'
import { useLocation, Link, useNavigate } from 'react-router-dom';

// Icons
import Home from '../../assets/icons/menu/home.svg';
import Basket from '../../assets/icons/menu/basket.svg';
import Location from '../../assets/icons/menu/location.svg';
import Blog from '../../assets/icons/menu/blog.svg';
import info from '../../assets/icons/menu/info.svg';
import Shop from '../../assets/icons/menu/shop.svg';
import Headphone from '../../assets/icons/menu/headphone.svg';
import PersonalCard from '../../assets/icons/menu/personal-card.svg';
import Search from '../../assets/icons/search.svg'


//active
import HomeActive from '../../assets/icons/menu/active/home.svg';
import BasketActive from '../../assets/icons/menu/active/basket.svg';
import LocationActive from '../../assets/icons/menu/active/location.svg';
import BlogActive from '../../assets/icons/menu/active/blog.svg';
import infoActive from '../../assets/icons/menu/active/info.svg';
import ShopActive from '../../assets/icons/menu/active/shop.svg';
import HeadphoneActive from '../../assets/icons/menu/active/headphone.svg';
import PersonalCardActive from '../../assets/icons/menu/active/personal-card.svg';
import Menu from '../../assets/icons/menu/menu.svg';
import { baseUrl, getCategory, getPopup, getProductsBySearch, imgBaseUrl } from '../../utils/api';
import PopupIcon from '../../assets/icons/popup.svg';

const NavbarComponent = () => {
  const [visibleRight, setVisibleRight] = useState(false);
  const [noPopup, setNoPopup] = useState(false);
  const [categories, setCategories] = useState([]);
  const [popup, setPopup] = useState([]);
  const [isProductsOpen, setIsProductsOpen] = useState(false); // برای مدیریت باز و بسته شدن بخش محصولات
  const location = useLocation();
  const [searchText, setSearchText] = useState('');
  const navigate = useNavigate(); // useNavigate for navigation without refresh

  const { setNav } = useContext(NavContext);
  const changeNav = (name) => setNav(name);

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const pay = { pageSize: 100, pageIndex: 0 };
        const res = await getCategory(pay);
        const items = res.data.data.items;
        localStorage.setItem('categoriesList', JSON.stringify(items.filter(product => product.isActive == true)))
        setCategories(items);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchPopup = async () => {
      try {
        const pay = { pageSize: 0, pageIndex: 0 };
        const res = await getPopup(pay);
        const items = res.data.data.items;
        console.log('..', items)
        if (items.filter(product => product.isActive == true).length == 0) {
          setNoPopup(true)
        }
        setPopup(items.filter(product => product.isActive == true));
        console.log(popup)
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
    fetchPopup();
  }, []);
  const handleAllPopupsDismissed = () => {
    setNoPopup(true)
  };

  const [hoveredCategory, setHoveredCategory] = useState(null);

  const handleMouseEnterCategory = (categoryName) => {
    setHoveredCategory(categoryName);
  };

  const handleMouseLeaveCategory = () => {
    setHoveredCategory(null);
  };

  const [categoriesPackage, setCategoriesPackage] = useState([]);
  const loadCategoriesWithProducts = async () => {
    try {
      const response = await getCategory({ pageSize: 100, pageIndex: 0 });
      const categories =
        response && response.data && response.data.data && response.data.data.items
          ? response.data.data.items
          : [];

      for (let i = 0; i < categories.length; i++) {
        const item = categories[i];
        const productRes = await getProductsBySearch({ productGroupId: item.id });
        const products =
          productRes && productRes.data && productRes.data.data && productRes.data.data.items
            ? productRes.data.data.items
            : [];

        item["products"] = products;
      }

      setCategoriesPackage(
        categories.filter((category) => category.isActive === true)
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    loadCategoriesWithProducts();

  }, []);

  useEffect(() => {

  }, [noPopup]);


  const closeCategoriesList = () => {
    document.body.click();
  };


  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <PopupDisplay popup={popup} onAllPopupsDismissed={handleAllPopupsDismissed} />


      <Navbar expand='lg' className='web-nav' >

        <div className={`navbar-menu w-100 d-flex align-items-center justify-content-between ${isScrolled ? "fixed-navbar show" : ""}`}>
          <div className='d-flex align-items-center justify-content-between  w-100'>
            <Navbar.Collapse id="basic-navbar-nav">
              <img src={Logo} alt="Logo" width={85} />
              <Nav activeKey={location.pathname}>
                <Nav.Item>
                  <Nav.Link className='d-flex align-items-start gap-1' href="/" active={location.pathname === "/"}><img src={location.pathname === "/" ? HomeActive : Home} alt="Home" width={19} />خانه</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <NavDropdown active={location.pathname === "/products" || location.pathname === "/product"} className='[&_.dropdown-menu.show]:!w-auto' title={<div className='d-flex align-items-start'><h6 className='nav-link p-0  d-flex align-items-start gap-1' ><img src={location.pathname === "/products" || location.pathname === "/product" ? BasketActive : Basket} alt="Products" width={19} />محصولات</h6>
                    <div style={{ width: '20px', marginRight: '5px' }}>
                      <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.2797 5.9668L8.93306 10.3135C8.41973 10.8268 7.57973 10.8268 7.06639 10.3135L2.71973 5.9668" stroke="#494C50" strokeWidth="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </div>

                  </div>} id="nav-dropdown">
                    <div style={{ display: "flex" }}>
                      {/* Categories Column */}
                      <div
                        className={`${hoveredCategory ? "border-l-[#00A14B] border-l-[1px]" : ''}`}
                      // onMouseLeave={handleMouseLeaveCategory}
                      >
                        <NavDropdown.Item
                          onMouseEnter={() => handleMouseEnterCategory('')}
                          href={`/products?categoryId=`}
                        >
                          <div className={`${hoveredCategory === '' ? "text-[#00A14B] font-bold" : ''}`}>
                            همه محصولات
                          </div>
                        </NavDropdown.Item>
                        {categoriesPackage.map((category, index) => (
                          <NavDropdown.Item
                            key={index}
                            onMouseEnter={() => handleMouseEnterCategory(category.id)}
                            href={`/products?categoryId=${category.id}`}
                          >
                            <div className={`${hoveredCategory === category.id ? "text-[#00A14B] font-bold" : ''}`}>
                              {category.title}
                            </div>
                          </NavDropdown.Item>
                        ))}
                      </div>

                      {/* Products Column */}
                      {hoveredCategory && (
                        <div
                          className='w-[40vw] flex items-start flex-wrap px-1 h-fit'
                        >
                          {
                            (() => {
                              const selectedCategory = categoriesPackage.find((category) => category.id === hoveredCategory);

                              if (
                                selectedCategory &&
                                selectedCategory.products &&
                                selectedCategory.products.length > 0
                              ) {
                                return selectedCategory.products.map((product, productIndex) => (
                                  <Link
                                    to={`/product?id=${product.id}`}
                                    onClick={closeCategoriesList}
                                    className="mt-2 px-1 py-2 rounded cursor-pointer hover:bg-[#00A14B] text-[#000] hover:text-[#fff] !w-1/3 flex gap-2"
                                    key={productIndex}
                                  >
                                    <div className="w-6 h-6 flex justify-center items-center">
                                      <img
                                        src={product.images && product.images[0] ? baseUrl + "/IO/20x25/" + product.images[0].url : ""}
                                        alt=""
                                        className="rounded-sm"
                                      />
                                    </div>
                                    <div className="text-sm text-right title-menu">{product.title}</div>
                                  </Link>
                                ));
                              }

                              return null;
                            })()
                          }

                        </div>
                      )}
                    </div>
                  </NavDropdown>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link className='d-flex align-items-start gap-1' href="/shop" active={location.pathname === "/shop"}>  <img src={location.pathname === "/shop" ? ShopActive : Shop} alt="shop" width={19} /> فروشگاه</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link className='d-flex align-items-start gap-1' href="/branches" active={location.pathname === "/branches"}>  <img src={location.pathname === "/branches" ? LocationActive : Location} alt="Branches" width={19} /> شعب</Nav.Link>
                </Nav.Item>
                {/* <Nav.Item>
                  <Nav.Link href="/blogs" active={location.pathname === "/blogs"}>بلاگ و اخبار</Nav.Link>
                </Nav.Item> */}
                <Nav.Item>
                  <Nav.Link className='d-flex align-items-start gap-1' href="/about-us" active={location.pathname === "/about-us"}> <img src={location.pathname === "/about-us" ? infoActive : info} alt="About Us" width={19} />درباره ما</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link className='d-flex align-items-start gap-1' href="/contact-us" active={location.pathname === "/contact-us"}> <img src={location.pathname === "/contact-us" ? HeadphoneActive : Headphone} alt="Contact Us" width={19} />امور مشتریان</Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link className='d-flex align-items-start gap-1' href="/employment" active={location.pathname === "/employment"}> <img src={location.pathname === "/employment" ? PersonalCardActive : PersonalCard} alt="Employment" width={19} />استخدام و همکاری</Nav.Link>
                </Nav.Item>
              </Nav>
            </Navbar.Collapse>
            <div className='d-flex align-items-center gap-2 search'>
              <div className={` input-icon `} style={isScrolled ? {borderColor : '#669D24'} : {borderColor: '#669D24'}}>
                <input className='form-control' placeholder='جستجو...' value={searchText}
                  onChange={(e) => setSearchText(e.target.value)} onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault(); // Prevent form submission
                      navigate(`/products?title=${e.target.value}&&categoryId=`);
                    }
                  }}></input>
                <button className=' m-0 p-1' onClick={() => { navigate(`/products?title=${searchText}&&categoryId=`); }}><img src={Search} alt="" /></button>
              </div>
              <button
                className="btn btn-primary d-flex align-items-center gap-2 h-[48px]"
                onClick={() => { window.location.href = 'https://club.benicejuice.com'; }}
              >
                <img src={Profile} alt="Profile" />باشگاه مشتریان
              </button>
            </div>
          </div>
        </div>
      </Navbar>

      {/* Mobile Navbar */}

      <Navbar
        style={noPopup ? { top: '3em' } : { top: '7em' }}

        className="px-2 bg-body-tertiary mb-3 mobile-nav d-flex align-items-center justify-content-between"
        dir="rtl" // Setting text direction to RTL
      >
        <img src={Menu} alt="Menu" onClick={() => setVisibleRight(true)} />
        <div style={{ width: '50px' }}>

          <img src={Logo} alt="Logo" />
        </div>
      </Navbar>


      <Sidebar
        visible={visibleRight}
        onHide={() => setVisibleRight(false)}
        position="right"
        style={{ position: 'relative', width: '80%' }}
      >
        <Divider />
        <div className='menu-items'>
          {/* آیتم‌های ثابت */}
          <div className='d-flex align-items-center gap-2 mb-3' active={location.pathname === "/"} onClick={() => { window.location.href = '/' }}>
            <img src={location.pathname === "/" ? HomeActive : Home} alt="Home" />
            <span style={location.pathname === "/" ? { color: '#00A14B' } : { color: '#4b5563' }}>خانه</span>
          </div>
          <hr style={{ color: '#80d0a5', opacity: '1' }} />

          {/* محصولات با حالت کشویی */}
          <div className='d-flex flex-column mb-3'>
            <div
              className='d-flex align-items-center justify-content-between'
              onClick={() => setIsProductsOpen(!isProductsOpen)} // کلیک برای باز و بسته شدن منو
              style={{ cursor: 'pointer' }}
            >
              <div className='d-flex align-items-center gap-2'>
                <img src={location.pathname === "/products" || location.pathname === "/product" ? BasketActive : Basket} alt="Products" />
                <span style={location.pathname === "/products" || location.pathname === "/product" ? { color: '#00A14B' } : { color: '#4b5563' }}>محصولات</span>
              </div>

              <img src={ArrowDown} alt="Expand" style={{ transform: isProductsOpen ? 'rotate(180deg)' : 'rotate(0deg)' }} />
            </div>

            {isProductsOpen && (
              <div className="px-4 mt-3">
                {/* <hr style={{ color: '#80d0a5', opacity: '1', margin: '2px' }} /> */}

                <a href="/products" className="d-block mb-2 text-sm	mx-4 " >همه</a>
                {/* <hr style={{ color: '#80d0a5', opacity: '1', margin: '2px' }} /> */}
                {categories.map((category, index) => (
                  <React.Fragment key={index}>

                    <a href={`/products?categoryId=${category.id}`} className="d-flex align-items-start gap-2 mb-2 text-sm	">      <img src={imgBaseUrl + category.logoPath} alt="" width={18} />
                      {category.title}
                    </a>

                    {/* {index < categories.length - 1 && (
                      <hr style={{ color: '#80d0a5', opacity: '1', margin: '2px' }} />
                    )} */}
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
          <hr style={{ color: '#80d0a5', opacity: '1' }} />

          {/* سایر آیتم‌ها */}
          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/branches' }}>
            <img src={location.pathname === "/branches" ? LocationActive : Location} alt="Branches" />
            <span style={location.pathname === "/branches" ? { color: '#00A14B' } : { color: '#4b5563' }}>شعب</span>
          </div>
          <hr style={{ color: '#80d0a5', opacity: '1' }} />

          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/blogs' }}>
            <img src={location.pathname === "/blogs" ? BlogActive : Blog} alt="Blog and News" />
            <span style={location.pathname === "/blogs" ? { color: '#00A14B' } : { color: '#4b5563' }}>بلاگ و اخبار</span>
          </div>
          <hr style={{ color: '#80d0a5', opacity: '1' }} />

          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/about-us' }}>
            <img src={location.pathname === "/about-us" ? infoActive : info} alt="About Us" />
            <span style={location.pathname === "/about-us" ? { color: '#00A14B' } : { color: '#4b5563' }}>درباره ما</span>
          </div>
          <hr style={{ color: '#80d0a5', opacity: '1' }} />

          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/contact-us' }}>
            <img src={location.pathname === "/contact-us" ? HeadphoneActive : Headphone} alt="Contact Us" />
            <span style={location.pathname === "/contact-us" ? { color: '#00A14B' } : { color: '#4b5563' }}>امور مشتریان</span>
          </div>
          <hr style={{ color: '#80d0a5', opacity: '1' }} />

          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/shop' }}>
            <img src={location.pathname === "/shop" ? ShopActive : Shop} alt="Contact Us" />
            <span style={location.pathname === "/shop" ? { color: '#00A14B' } : { color: '#4b5563' }}>فروشگاه</span>
          </div>
          <hr style={{ color: '#80d0a5', opacity: '1' }} />

          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = '/employment' }}>
            <img src={location.pathname === "/employment" ? PersonalCardActive : PersonalCard} alt="Employment" />
            <span style={location.pathname === "/employment" ? { color: '#00A14B' } : { color: '#4b5563' }}>استخدام و همکاری</span>
          </div>
          <hr style={{ color: '#80d0a5', opacity: '1' }} />

          <div className='d-flex align-items-center gap-2 mb-3' onClick={() => { window.location.href = 'https://club.benice.ir/' }}>
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.8901 12.7797C12.8201 12.7697 12.7301 12.7697 12.6501 12.7797C10.8901 12.7197 9.49011 11.2797 9.49011 9.50974C9.49011 7.69974 10.9501 6.22974 12.7701 6.22974C14.5801 6.22974 16.0501 7.69974 16.0501 9.50974C16.0401 11.2797 14.6501 12.7197 12.8901 12.7797Z" stroke="#494C50" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M19.5102 19.3798C17.7302 21.0098 15.3702 21.9998 12.7702 21.9998C10.1702 21.9998 7.81015 21.0098 6.03015 19.3798C6.13015 18.4398 6.73015 17.5198 7.80015 16.7998C10.5402 14.9798 15.0202 14.9798 17.7402 16.7998C18.8102 17.5198 19.4102 18.4398 19.5102 19.3798Z" stroke="#494C50" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M12.7701 21.9998C18.293 21.9998 22.7701 17.5226 22.7701 11.9998C22.7701 6.47691 18.293 1.99976 12.7701 1.99976C7.24729 1.99976 2.77014 6.47691 2.77014 11.9998C2.77014 17.5226 7.24729 21.9998 12.7701 21.9998Z" stroke="#494C50" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>

            <span>باشگاه مشتریان</span>
          </div>

        </div>
      </Sidebar>

    </>
  );
};

export default NavbarComponent;
